import React from 'react';
import {
  withSystem,
  Atom,
  type AtomRenderProps,
  Types,
} from '@packages/systems/wfdl';
import {extraAtomFields} from '@packages/shared/constants/Atoms';

import {TListOfElement, TRecord, TText} from '@packages/systems/wfdl-ast';
import {getChildren} from '@packages/utilities/data-utils';
import {defaultIntegratedTypes} from '@packages/utilities/integrated-types';

const FormFileUploadUploading = Atom.createRender(
  ({
    attributes,
    classes,
    generateAttributes,
    data,
    renderChild,
    context,
  }: AtomRenderProps) => {
    const uploadingState = context.get('formFileUploadState') === 'uploading';
    const updatedClasses = classes.push(
      uploadingState
        ? 'w-file-upload-uploading'
        : 'w-file-upload-uploading w-hidden'
    );

    return (
      <div {...generateAttributes(attributes, updatedClasses)}>
        {getChildren(data).map((child) => renderChild(child))}
      </div>
    );
  }
);

const config = Atom.create({
  displayName: 'Uploading State',
  showEmpty: true,
  constraints: {
    pinToParent: true,
    descendants: [{is: 'FormFileUploadUploadingBtn', rule: 'ExactlyOne'}],
  },
  render: FormFileUploadUploading,
  dataType: withSystem(
    {private: true},
    TRecord(
      Types.deepMergeTypes(defaultIntegratedTypes, {
        attr: TRecord({
          tabIndex: withSystem({defaultValue: '-1'}, TText),
        }),
        children: TListOfElement,
      }),
      extraAtomFields
    )
  ),
});

export default config;
